import { useCallback } from 'react';
import { toast } from 'sonner';
import { getTotalRecords, getRows } from '@/utils';
import taxService from '@/services/billing/taxService';

const toTaxOptions = (rows) =>
    rows.map(tax => ({
        label: tax.name,
        value: tax.name,
        id: tax.id.toString(),
        rate: tax.rate,
        original: tax,
    }));

const useTaxOptions = ({
    defaultPageSize = 20,
} = {}) => {
    const loadOptions = useCallback(
        async ({ search = '', page = 1, pageSize = defaultPageSize } = {}) => {
            try {
                const response = await taxService.getAllTax({
                    page,
                    pageSize,
                    search,
                });

                const status =
                    typeof response?.status === 'boolean' ? response.status : true;
                if (!status) return { options: [], hasMore: false };

                let rows = getRows(response);
                const options = toTaxOptions(rows);

                const totalRecords = getTotalRecords(response);
                const hasMore =
                    typeof totalRecords === 'number'
                        ? page * pageSize < totalRecords
                        : options.length === pageSize;

                return { options, hasMore };
            } catch (error) {
                console.error('Error', error);
                toast.error('Failed to fetch Tax.', {
                    description: 'Please try again.',
                });
                return { options: [], hasMore: false };
            }
        },
        [defaultPageSize]
    );

    return loadOptions;
};

export { useTaxOptions };
